import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import RouteSidebar from './sidebars/RouteSidebar';
import { getSidebarPlacement } from '../../util/routeNavigation';

function SidebarPageLayout({ children, id }) {
  const { pathname } = useLocation();
  const [isSidebarHidden, setIsSidebarHidden] = useState(false);
  const placement = getSidebarPlacement(pathname);

  return (
    <div
      id={id}
      className={`body d-flex flex-row align-items-stretch ${isSidebarHidden ? 'sidebarHidden' : 'sidebarShown'}`}
    >
      <RouteSidebar
        placement={placement}
        onToggle={() => setIsSidebarHidden((hidden) => !hidden)}
      />
      {children}
    </div>
  );
}

export default SidebarPageLayout;
